import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import OptionsToggle from './OptionsToggle';

const OptionsSection = ({ label, options, onToggle }) => {
    return (
        <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
                {label}
            </Form.Label>
            <Col sm={9}>
                <OptionsToggle
                    options={options}
                    onToggle={onToggle}
                />
            </Col>
        </Form.Group>
    );
};

export default OptionsSection;
